import { LogLevel } from '@nts/std/src/lib/utility';

export const environment = {
  production: true,
  baseAppUrl: 'https://ntsintratenantwebapp.ntsinformatica.it',
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'WebIntraTenant - DEV',
  appSubTitle: '',
  logLevel: LogLevel.All,
  isEnterpriseBarrierRequired: true
};
